import React from "react";

/**
 * Reusable SVG icon primitive.
 * @param {object} props
 * @param {React.ReactNode} props.children - SVG path elements
 * @param {string} [props.className] - CSS class name
 * @param {number} [props.size=16] - Icon width/height
 */
export default function Icon({ children, className, size = 16 }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}